import {Component} from 'react'
import Cookies from 'js-cookie'
import Loader from 'react-loader-spinner'
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'

import {IoClose, IoSearch} from 'react-icons/io5'

import Header from '../Header'
import Sidebar from '../Sidebar'
import Videos from '../Videos'

import ModeContext from '../../context/ModeContext'

import {
  Flex,
  HomeContainer,
  Banner,
  BannerCard,
  BImg,
  BText,
  BBtn,
  Button,
  HomeSection,
  SearchCard,
  Search,
  SearchBtn,
  HomeCards,
  NoResults,
  NoRImg,
  NoR,
  NoRPara,
  RetryButton,
} from './styledComponents'

const apiStatusConstants = {
  initial: 'INITIAL',
  success: 'SUCCESS',
  failure: 'FAILURE',
  inProgress: 'IN_PROGRESS',
}

class Home extends Component {
  state = {
    videosList: [],
    searchInput: '',
    apiStatus: apiStatusConstants.initial,
    isBannerShown: true,
  }

  componentDidMount() {
    this.getVideos()
  }

  getVideos = async () => {
    this.setState({apiStatus: apiStatusConstants.inProgress})

    const {searchInput} = this.state
    const jwtToken = Cookies.get('jwt_token')
    const url = `https://apis.ccbp.in/videos/all?search=${searchInput}`
    const options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    }
    const response = await fetch(url, options)

    if (response.ok) {
      const data = await response.json()
      const updatedData = {
        total: data.total,
        videos: data.videos.map(each => ({
          id: each.id,
          publishedAt: each.published_at,
          thumbnailUrl: each.thumbnail_url,
          title: each.title,
          viewCount: each.view_count,
          channel: {
            name: each.channel.name,
            profileImageUrl: each.channel.profile_image_url,
          },
        })),
      }
      this.setState({
        videosList: updatedData.videos,
        apiStatus: apiStatusConstants.success,
      })
    } else {
      this.setState({apiStatus: apiStatusConstants.failure})
    }
  }

  onClickClose = () => {
    this.setState({isBannerShown: false})
  }

  onChangeSearchInput = e => {
    this.setState({searchInput: e.target.value})
  }

  onClickEnterBtn = e => {
    if (e.key === 'Enter') {
      console.log(e.target.value)
      this.setState({searchInput: e.target.value}, this.getVideos)
    }
  }

  onClickSearchBtn = () => {
    this.getVideos()
  }

  onClickRetry = () => {
    this.getVideos()
  }

  renderLoader = () => (
    <div className="loader-container" data-testid="loader">
      <Loader type="ThreeDots" color="#ffffff" height="50" width="50" />
    </div>
  )

  renderFailure = () => (
    <ModeContext.Consumer>
      {value => {
        const {isDarkMode} = value
        const color = isDarkMode ? 'white' : 'black'
        const src = isDarkMode
          ? 'https://assets.ccbp.in/frontend/react-js/nxt-watch-failure-view-dark-theme-img.png'
          : 'https://assets.ccbp.in/frontend/react-js/nxt-watch-failure-view-light-theme-img.png'

        return (
          <NoResults>
            <NoRImg failure src={src} alt="failure view" />
            <NoR color={color}>Oops! Something Went Wrong</NoR>
            <NoRPara>
              We are having some trouble to complete your request.
              <br />
              Please try again.
            </NoRPara>
            <RetryButton onClick={this.onClickRetry}>Retry</RetryButton>
          </NoResults>
        )
      }}
    </ModeContext.Consumer>
  )

  renderSuccess = () => {
    const {videosList, searchInput} = this.state
    const filteredList = videosList.filter(each =>
      each.title.toLowerCase().includes(searchInput.toLowerCase()),
    )

    if (filteredList.length === 0) {
      return (
        <ModeContext.Consumer>
          {value => {
            const {isDarkMode} = value
            const color = isDarkMode ? 'white' : 'black'

            return (
              <NoResults>
                <NoRImg
                  src="https://assets.ccbp.in/frontend/react-js/nxt-watch-no-search-results-img.png"
                  alt="no videos"
                />
                <NoR color={color}>No Search results found</NoR>
                <NoRPara>
                  Try different key words or remove search filter
                </NoRPara>
                <RetryButton onClick={this.onClickRetry}>Retry</RetryButton>
              </NoResults>
            )
          }}
        </ModeContext.Consumer>
      )
    }

    return (
      <HomeCards>
        {filteredList.map(each => (
          <Videos key={each.id} video={each} />
        ))}
      </HomeCards>
    )
  }

  renderVideos = () => {
    const {apiStatus} = this.state

    switch (apiStatus) {
      case apiStatusConstants.success:
        return this.renderSuccess()
      case apiStatusConstants.failure:
        return this.renderFailure()
      case apiStatusConstants.inProgress:
        return this.renderLoader()
      default:
        return null
    }
  }

  renderSearchBar = () => {
    const {searchInput} = this.state

    return (
      <ModeContext.Consumer>
        {value => {
          const {isDarkMode} = value
          const searchBg = isDarkMode ? 'transparent' : 'white'
          const searchBorder = isDarkMode ? '#606060' : '#d7dfe9'
          const searchColor = isDarkMode ? 'lightgray' : 'black'

          return (
            <SearchCard searchBg={searchBg} searchBorder={searchBorder}>
              <Search
                type="search"
                placeholder="Search"
                value={searchInput}
                searchColor={searchColor}
                onChange={this.onChangeSearchInput}
                onKeyDown={this.onClickEnterBtn}
              />
              <SearchBtn
                onClick={this.onClickSearchBtn}
                data-testid="searchButton"
                dark={isDarkMode}
              >
                <IoSearch />
              </SearchBtn>
            </SearchCard>
          )
        }}
      </ModeContext.Consumer>
    )
  }

  renderBanner = () => {
    const {isBannerShown} = this.state
    return (
      <>
        {isBannerShown && (
          <Banner data-testid="banner">
            <BannerCard>
              <BImg
                src="https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-light-theme-img.png"
                alt="nxt watch logo"
              />
              <BText>Buy Nxt Watch Premium prepaid plans with UPI</BText>
              <BBtn>GET IT NOW</BBtn>
            </BannerCard>
            <Button onClick={this.onClickClose} data-testid="close" id="btn">
              <IoClose id="close" />
            </Button>
          </Banner>
        )}
      </>
    )
  }

  render() {
    return (
      <ModeContext.Consumer>
        {value => {
          const {isDarkMode} = value
          const bgColor = isDarkMode ? '#181818' : '#f9f9f9'

          return (
            <>
              <Header />
              <Flex>
                <Sidebar />
                <HomeContainer data-testid="home" bgColor={bgColor}>
                  {this.renderBanner()}
                  <HomeSection>
                    {this.renderSearchBar()}
                    {this.renderVideos()}
                  </HomeSection>
                </HomeContainer>
              </Flex>
            </>
          )
        }}
      </ModeContext.Consumer>
    )
  }
}

export default Home
